import { uuid } from "app/utils/uuid";
import React, { forwardRef } from "react";

interface Props {
  label?: string;
  placeholder?: string;
  value?: string;
  name?: string;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  required?: boolean;
  'data-testid'?: string;
}

const TextInput = forwardRef<HTMLInputElement, Props>(
  ({
    label,
    placeholder,
    value,
    name,
    disabled = false,
    onChange,
    onBlur,
    required,
    ...rest
  }, ref) => {
    const id = uuid();
    const testId = rest['data-testid'] || (name ? `${name}-input` : undefined);

    return (
      <>
        {label && <label htmlFor={id}>{label}</label>}
        <input
          id={id}
          name={name}
          type="text"
          value={value}
          disabled={disabled}
          onChange={onChange}
          onBlur={onBlur}
          ref={ref}
          placeholder={placeholder}
          required={required}
          data-testid={testId}
        />
      </>
    );
  }
);
TextInput.displayName = "TextInput";

export default TextInput;
